export default __webpack_public_path__ + "static/media/certificateOfRegistration.124ad1c2.jpeg";